import { makeActionCreator } from '../../../../utilities'
import { VentilatorConstants } from './ventilator.constants'

export const setVentilatorCheck = makeActionCreator(VentilatorConstants.SET_VENTILATOR_CHECK, 'ventilatorCheck')
export const setMode = makeActionCreator(VentilatorConstants.SET_MODE, 'mode')
export const setBreathType = makeActionCreator(VentilatorConstants.SET_BREATH_TYPE, 'breathType')
export const setSettingsRespRate = makeActionCreator(VentilatorConstants.SET_SETTINGS_RESP_RATE, 'settingsRespRate')
export const setTidalVolume = makeActionCreator(VentilatorConstants.SET_TIDAL_VOLUME, 'tidalVolume')
export const setInspPressure = makeActionCreator(VentilatorConstants.SET_INSP_PRESSURE, 'inspPressure')
export const setPEEP = makeActionCreator(VentilatorConstants.SET_PEEP, 'pEEP')
export const setFiO2 = makeActionCreator(VentilatorConstants.SET_FIO2, 'fiO2')
export const setAirTemperature = makeActionCreator(VentilatorConstants.SET_AIR_TEMPERATURE, 'airTemperature')
export const setAirTemperatureUnit = makeActionCreator(
  VentilatorConstants.SET_AIR_TEMPERATURE_UNIT,
  'airTemperatureBool'
)
export const setAirTemperatureUnitTemp = makeActionCreator(
  VentilatorConstants.SET_AIR_TEMPERATURE_UNIT_TEMP,
  'airTemperatureUnit'
)

export const setHumidityAir = makeActionCreator(VentilatorConstants.SET_HUMIDITY_AIR, 'humidityAir')
export const setITime = makeActionCreator(VentilatorConstants.SET_I_TIME, 'iTime')
export const setPressureSupport = makeActionCreator(VentilatorConstants.SET_PRESSURE_SUPPORT, 'pressureSupport')
export const setFlowRate = makeActionCreator(VentilatorConstants.SET_FLOW_RATE, 'flowRate')
export const setSensitivity = makeActionCreator(VentilatorConstants.SET_SENSITIVITY, 'sensitivity')
export const setMeanAirwayPressure = makeActionCreator(
  VentilatorConstants.SET_MEAN_AIRWAY_PRESSURE,
  'meanAirwayPressure'
)
export const setDeltaP = makeActionCreator(VentilatorConstants.SET_DELTA_P, 'deltaP')
export const setHertz = makeActionCreator(VentilatorConstants.SET_HERTZ, 'hertz')
export const setINO = makeActionCreator(VentilatorConstants.SET_INO, 'iNO')
export const setPeakInspPressure = makeActionCreator(VentilatorConstants.SET_PEAK_INSP_PRESSURE, 'peakInspPressure')
export const setPlateauPressure = makeActionCreator(VentilatorConstants.SET_PLATEAU_PRESSURE, 'plateauPressure')
export const setAutoPEEP = makeActionCreator(VentilatorConstants.SET_AUTO_PEEP, 'autoPEEP')
export const setMinuteVent = makeActionCreator(VentilatorConstants.SET_MINUTE_VENT, 'minuteVent')
export const setIERatio = makeActionCreator(VentilatorConstants.SET_I_E_RATIO, 'iERatio')
export const setMeasurementRespRate = makeActionCreator(
  VentilatorConstants.SET_MEASUREMENT_RESP_RATE,
  'measurementRespRate'
)
export const setExhaledTidalVolume = makeActionCreator(
  VentilatorConstants.SET_EXHALED_TIDAL_VOLUME,
  'exhaledTidalVolume'
)
export const setETCuffPressureMeasurement = makeActionCreator(
  VentilatorConstants.SET_ET_CUFF_PRESSURE_MEASUREMENT,
  'eTCuffPressureMeasurement'
)
export const setInspiratoryResistance = makeActionCreator(
  VentilatorConstants.SET_INSPIRATORY_RESISTANCE,
  'inspiratoryResistance'
)
export const setStaticCompliance = makeActionCreator(VentilatorConstants.SET_STATIC_COMPLIANCE, 'staticCompliance')
export const setExpiratoryTimeConstant = makeActionCreator(
  VentilatorConstants.SET_EXPIRATORY_TIME_CONSTANT,
  'expiratoryTimeConstant'
)
export const setAction = makeActionCreator(VentilatorConstants.SET_ACTION, 'action')
export const saveVentilator = makeActionCreator(VentilatorConstants.SAVE_VENTILATOR, 'data')
export const resetState = makeActionCreator(VentilatorConstants.RESET_STATE)
export const setAddToTimeLine = makeActionCreator(VentilatorConstants.SET_ADD_TO_TIMELINE, 'addToTimeline')
export const setState = makeActionCreator(VentilatorConstants.SET_STATE, 'ventilatorState')
export const setDateTime = makeActionCreator(VentilatorConstants.SET_DATE_TIME, 'time', 'date')
export const setAssessedBy = makeActionCreator(VentilatorConstants.SET_ASSESSED_BY, 'assessedBy')
export const onSelectVentilatorProcedure = makeActionCreator(VentilatorConstants.ON_SELECT_VENTILATOR)
export const setUpdateInputRows = makeActionCreator(VentilatorConstants.SET_UPDATE_INPUT_ROWS, 'updateInputRows')
export const setSize = makeActionCreator(VentilatorConstants.SET_SIZE, 'size')
export const setRolePerforming = makeActionCreator(VentilatorConstants.SET_ROLE_PERFORMING, 'rolePerforming')
export const getPreviousVentilatorState = makeActionCreator(VentilatorConstants.GET_PREVIOUS_VENTILATOR_STATE)
export const setProcedurePerformedByAnotherUnit = makeActionCreator(
  VentilatorConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT,
  'procedurePerformedByAnotherUnit'
)
export const setProcedurePerformedByAnotherUnitPNNV = makeActionCreator(
  VentilatorConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV,
  'procedurePerformedByAnotherUnitPNNV'
)
